/* eslint-disable */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import JobPostManagement from './JobPostManagement';
import JobEmployerManagement from './JobEmployerManagement';
import JobSeekerManagement from './JobSeekerManagement';
import JobCategoryManagement from './JobCategoryManagement';
import JobOverviewDashboard from './JobOverviewDashboard';

function Job(props) {
  return (
    <Routes>
      <Route
        path="/posts"
        element={<JobPostManagement app_hostname={props.app_hostname} permitdata={props.permitdata} />}
      />
      <Route
        path="/employers"
        element={<JobEmployerManagement app_hostname={props.app_hostname} permitdata={props.permitdata} />}
      />
      <Route
        path="/seekers"
        element={<JobSeekerManagement app_hostname={props.app_hostname} permitdata={props.permitdata} />}
      />
      <Route
        path="/categories"
        element={<JobCategoryManagement app_hostname={props.app_hostname} permitdata={props.permitdata} />}
      />
      <Route
        path="/overview"
        element={<JobOverviewDashboard app_hostname={props.app_hostname} permitdata={props.permitdata} />}
      />
    </Routes>
  );
}

Job.propTypes = {
  app_hostname: PropTypes.string,
  permitdata: PropTypes.object,
};

export default Job;
